const config = {
  trafficPercentage: 0.25
};

export default config;
